import ListingVM from './listing-vm';
import Vue from 'vue';
export default {
  init : function(element) {
    console.log('Initializing Student Gradebook Listing');
    let vm = new Vue(ListingVM);
    vm.$mount(element);
  }
};
